import React from 'react'
import Container from 'react-bootstrap/Container'
import Typist from 'react-typist-component'
import {Jumbotron} from './migration'

const MainBody = React.forwardRef(
    ({gradient, title, message, icons}, ref) => {
        return (
            <Jumbotron
                className="title bg-transparent bgstyle text-light min-vh-100 d-flex align-content-center align-items-center flex-wrap m-0"
                fluid
                id="home"
                style={{
                    background: `linear-gradient(196deg,${gradient})`,
                    backgroundSize: '100% 1200%'
                }}
            >
                <div id="stars"></div>
                <Container className="text-center">
                    <h1 ref={ref} className="display-3">
                        {title}
                    </h1>
                    <Typist>
                        <div className="lead typist">
                            {message}
                        </div>
                    </Typist>
                    <div className="p-5">
                        {
                            icons.map((icon, index) => (
                                <a
                                    aria-label={`My ${icon.image.split('-')[1]}`}
                                    href={icon.url}
                                    key={`social-icon-${index}`}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    <i className={`fab ${icon.image} fa-3x socialicons`}/>
                                </a>
                            ))
                        }
                    </div>
                    <a
                        aria-label="Learn more about me"
                        className="btn btn-outline-light btn-lg "
                        href="#aboutme"
                        role="button"
                    >
                        More about me
                    </a>
                </Container>
            </Jumbotron>
        )
    }
)

export default MainBody